<template>
  <div class="main">
    <div class="bg-img-all">
      <div class="download-button-sty" @click="download_apk"></div>
      <div class="download-button-store" @click="download_apk"></div>
      <!-- <div class="finger"></div> -->
    </div>
  </div>
</template>

<script>
import { download, chnup, loadPage } from "../utils/tools";

export default {
  data() {
    return {};
  },
  methods: {
    download_apk: function (event) {
      chnup("click");
      download();
    },
  },
  created() {
    loadPage();
  },
};
</script>

<style lang="less" scoped>
.main {
  background: #fff;
  height: 100vh;
  width: 100vw;
}
.bg-img-all {
  width: 100vw;
  height: 177.78vw;
  background-image: url("../../static/mobileb/bg.jpg");
  background-size: cover;
  position: relative;
}
.download-button-sty {
  position: absolute;
  top: 22.92vw;
  left: 18.75vw;
  width: 62.64vw;
  height: 15.83vw;
  background-image: url("../../static/mobileb/download.png");
  background-size: cover;
  animation-name: scaleDraw;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
  animation-duration: 1s;
}
.download-button-store {
  position: absolute;
  top: 41.69vw;
  left: 20.97vw;
  width: 58.19vw;
  height: 15.69vw;
  background-image: url("../../static/mobileb/GalaxyStore.png");
  background-size: cover;
  animation-name: scaleDraw;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
  animation-duration: 1s;
}

@keyframes scaleDraw {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(1.1);
  }
  50% {
    transform: scale(1.1);
  }
  75% {
    transform: scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pageB.vue